import React from "react";

class About extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <React.Fragment>
        <section id="map-olympic-peninsula-loop" className="about-us gray-light-bg">
          <iframe
            src="https://maps.google.com/maps?saddr=Seattle,+WA&daddr=Port+Angeles,+WA+to:Hurricane+Ridge,+Olympic+National+Park,+WA+to:Hoh+Rain+Forest+Visitor+Center,+WA+to:Ruby+Beach,+WA+to:Lake+Quinault+Lodge,+WA+to:Seattle,+WA&output=embed"
            width="100%"
            height="420">
          </iframe>
        </section>
      </React.Fragment>
    );
  }
}

export default About;
